import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'czechNumberFormat'
})
export class CzechNumberFormatPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    value = ('' + value).replace(/(?!^)(?=(?:\d{3})+(?:\.|,|$))/gm, ' ');
    return value.replace(/[.]/g, ',');
  }

}
